/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { useHistory } from 'react-router-dom';
import { withGrowl } from '../../components/GrowlNotifications';
import { growlErrors } from '../../utils/NotificationUtil';
import { Loading } from '../../components/Loading';
import { withAccount } from '../../components/AccountContext';
import TransfersList from './TransfersList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../utils/UrlUtil';
import { VIEWER_LOCALE } from '../../components/Query';
import { growlShape } from '../../components/prop-types';

export const TRANSFERS_QUERY = gql`
  query TransferHistoryQuery(
    $accountId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: TransferHistoryFilter
    $sort: TransferHistorySortSpecifier
  ) {
    account(id: $accountId) {
      id
      organisationTransferHistory(
        first: $first
        after: $after
        last: $last
        before: $before
        filter: $filter
        sort: $sort
      ) {
        totalCount
        indexFrom
        indexTo
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            amount
            transferReason
            transactionTime
            fromAccount {
              id
              displayName
            }
            toAccount {
              id
              displayName
            }
            transferredBy {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;

const OrganisationTransfersQuery = ({ currentAccount, growl }) => {
  const { location } = useHistory();
  const params = parse(location.search);
  const pagination = filterPaginationWithSize(params);

  const variables = {
    ...pagination,
    accountId: currentAccount,
    sort: params.sort,
    filter: params.filter,
  };
  return (
    <Query query={VIEWER_LOCALE}>
      {({ data, loading, error }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          growlErrors(growl, error);
        }

        const locale = data && data.viewer ? data.viewer.locale : 'en-US';

        return (
          <Query query={TRANSFERS_QUERY} variables={variables} fetchPolicy="network-only">
            {({ data, loading, error }) => {
              if (error) return `Error! ${error.message}`;

              const connection = data && data.account ? data.account.organisationTransferHistory : emptyConnection();

              return (
                <TransfersList
                  connection={connection}
                  loading={loading}
                  currentAccount={currentAccount}
                  locale={locale}
                />
              );
            }}
          </Query>
        );
      }}
    </Query>
  );
};

OrganisationTransfersQuery.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
};

export default withGrowl(withAccount(OrganisationTransfersQuery));
